export const getUsedZpos = (state) =>
  state.usedZpos;
